export const ADD_BANK_ACCOUNTS = `
mutation(
    $profileId: ID
    $bankName: String
    $accountName: String
    $accountNumber: String
    $address: String
    $swiftCode: String
  ) {
    createAccount(
      input: {
        data: {
          profileId: $profileId
          bankName: $bankName
          accountName: $accountName
          accountNumber: $accountNumber
          address: $address
          swiftCode: $swiftCode
        }
      }
    ) {
      account {
        id
        profileId {
          id
        }
      }
    }
  }
`

export const WITHDRAW_REQUEST = `
mutation($amount: Int, $accountId: ID, $profileId: ID) {
  addWithdrawRequest(
    amount: $amount
    accountId: $accountId
    profileId: $profileId
  ) {
    status
    id
  }
}


`